var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLt = function SvgIconLt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M23.254 16.174c.482-1.3.746-2.706.746-4.174 0-1.467-.264-2.874-.746-4.174L12 6.783.746 7.826A12 12 0 0 0 0 12c0 1.468.264 2.874.746 4.174L12 17.218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M23.253 7.826C21.558 3.256 17.16 0 12 0 6.84 0 2.442 3.256.746 7.826z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 24c5.16 0 9.559-3.256 11.254-7.825H.747C2.443 20.745 6.841 24 12.001 24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconLt;